<!-- 创作台首页 -->
<template>
  <div class="writing">
    <div class="row">
      <div class="col">
        <div @click="newWriting()">
          <div class="imgbox">
            <img src="/static/images/new_writing.png" alt="" srcset="" />
          </div>
          <h3>新建论文</h3>
        </div>

         <div class="btn" @click="upmessage()" id="importDocBtn">
              导入文档
              <input
                class="files"
                @change="upfile"
                type="file"
                accept="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                name=""
                id=""
              />
          </div>

      </div>
      <div class="colspan" v-for="(item, index) in listData" :key="index">
        <div @click="gowriting(item.id)">
          <h3 :title="item.title">{{ item.title || "未命名" }}</h3>
          <p>
            <img src="/static/images/t.png" alt="" srcset="" />{{
              item.wordCount
            }}字
          </p>
          <p>
            <img src="/static/images/time.png" alt="" srcset="" />{{
              item.lastUpdateTime
            }}
          </p>
        </div>

        <div class="btn">
          <button @click="dowWriting(item.id)">
            <img src="/static/images/dow.png" alt="" srcset="" />导出项目
          </button>
          <el-popover
            width="55px"
            popper-class="mypopover"
            v-model="item.visible"
          >
            <div class="gd">
              <button class="savename" @click="setName(item)">重命名</button
              ><button class="rm" @click="del(item.id)">删除</button>
            </div>
            <el-button slot="reference"
              ><img src="/static/images/gd.png" alt="" srcset=""
            /></el-button>
          </el-popover>
        </div>
      </div>
    </div>
    <div class="pages" v-if="pages > 1">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="11"
        :total="total"
      >
      </el-pagination>
      共 {{ pages }} 页
    </div>

    <RechargePop :visible.sync="dialogVisible"></RechargePop>
      <!-- 成功弹窗 -->
    <el-dialog :visible.sync="vipPop" width="430px" center>
        <div class="modifyM-box" style="text-align: center; width:370px;height:183px">
            <div class="vip-suc">
                <img src="../../../static/images/acc_state_sucess.png" alt=""/>
                <p style="margin-top:32px;font-size:17px;color:#333439;font-weight:bold">支付成功</p>
            </div>
        </div>
    </el-dialog>

    <div class="limit-open-vip">
       <el-dialog
       :close-on-click-modal= "false"
        :visible.sync="opneVipVisible"
        width="500px"
        top="30vh"
        title="导出论文">
        <div class="open-vip-box">
          <div class="open-vip-box-message">今日2次导出机会已用完，开通会员继续享受</div>
          <button
              @click="goVip"
              class="check-glod-btn"
              style="margin-right:16px"
            >
              <span class="check-btn-text">开通会员</span>
            </button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import RechargePop from '@/components/recharge/rechargePop.vue';
export default {
  data: function() {
    return {
      listData: [],
      writingname: "这是论文标题",
      pages: 1,
      total: 0,
      page: {
        size: 11,
        current: 1
      },
      exportTimes: 0, // 导出次数
      dialogVisible: false,
      vipPop: false,
      guideShow: true,
      opneVipVisible: false
    };
  },
  components: {RechargePop},
  created: function() {
    this.initData();
    // this.getExportTimes();
    this.getGuideLimit();
  },
  mounted: function() {},
  methods: {
    dowWriting: function(id) {
      this.api.getToolsLimitCheck({type: 2}).then(res => {
        if (res.code == 0) {
          this.api.dowWriting(id);
        } else {
          this.opneVipVisible = true;
        }
      })
    },
    /**
     * 删除论文
     */
    del: function(id) {
      this.api.deleteWriting(id).then(res => {
        console.log(res.code);
        if (res.code == 0) {
          let mgs = `<div style="display: flex; align-items: center;"><img src="/static/images/gou.png" style="margin-right:5px;width:14px;height:14px" alt="" srcset="" /> 删除成功</div>`;
          this.$message({
            dangerouslyUseHTMLString: true,
            iconClass: "none",
            showClose: true,
            message: mgs,
            customClass: "mymessage",
            duration: 1000
          });

          if (this.listData.length == 1 && this.page.current > 1) {
            this.page.current = this.page.current - 1;
          }
          this.initData();
        }
      });
    },
    upfile: function(e) {
      let filetype = e.target.files[0].type;
      console.log(filetype);
      if (
        filetype == "application/msword" ||
        filetype ==
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ) {
        var formdata = new FormData();
        formdata.append("file", e.target.files[0]);
        this.api.upfile(formdata).then(res => {
          if (res.code == 0) {
            this.gowriting(res.data.id);
          } else {
            this.$message({
              message: res.msg,
              type: "warning"
            });
          }
        });
      } else {
        this.$prompt(
          '<p style="text-align: center;margin-bottom: 10px;color: #66686E;">只支持word格式文件</p>',
          "温馨提示",
          {
            showInput: false,
            dangerouslyUseHTMLString: true,
            cancelButtonClass: "myno",
            confirmButtonClass: "next",
            confirmButtonText: "重新选择",
            cancelButtonText: "取消"
          }
        )
          .then(res => {})
          .catch(() => {});
      }
    },
    upmessage: function() {
      document.getElementsByClassName("files")[0].click();
    },
    gowriting: function(id) {
      this.$router.push({
        name: "editor",
        query: {
          id: id
        }
      });
    },
    /**
            论文重命名
             */
    setName: function(item) {
      let _this = this;
      let Id = item.id;
      this.$prompt("重命名标题", "", {
        closeOnClickModal: false,
        cancelButtonClass: "myno",
        confirmButtonClass: "next",
        confirmButtonText: "确定",
        inputValue: item.title,
        inputPlaceholder: "输入关键词或论文标题(建议5-50字)",
        cancelButtonText: "取消",
        inputPattern: /^.{5,51}$/,
        inputErrorMessage: "标题格式不正确",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "执行中...";
            let params = {
              title: instance.inputValue,
              id: Id
            };
            _this.api.rename(params).then(res => {
              instance.confirmButtonLoading = false;
              _this.initData();
              done();
            });
            setTimeout(() => {
              instance.confirmButtonLoading = false;
              done();
            }, 10000);
          } else {
            done();
          }
        }
      }).catch(() => {});
    },
    /**
            新建论文
             */
    newWriting: function() {
      let _this = this;
      this.$prompt("新建论文", "", {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        cancelButtonClass: "myno",
        confirmButtonClass: "next",
        confirmButtonText: "开始写作",
        inputPlaceholder: "输入关键词或论文标题（建议5-50字)",
        cancelButtonText: "跳过",
        inputPattern: /^.{5,50}$/,
        inputErrorMessage: "输入不少于5字标题",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "执行中...";
            let params = {
              title: instance.inputValue,
              content: ""
            };
            _this.api.create(params).then(res => {
              instance.confirmButtonLoading = false;
              _this.initData();
              _this.gowriting(res.data.id);
              done();
            });
            setTimeout(() => {
              instance.confirmButtonLoading = false;
              done();
            }, 10000);
          } else if (action == "cancel") {
            let params = {
              title: "",
              content: ""
            };
            instance.confirmButtonLoading = false;
            _this.api.create(params).then(res => {
              instance.confirmButtonLoading = false;
              _this.initData();
              _this.gowriting(res.data.id);
              done();
            });
          } else {
            instance.confirmButtonLoading = false;
            done();
          }
        }
      }).catch(action => {
        console.log(action);
      });
    },

    /**
     * 获取论文列表
     */
    initData: function() {
      this.api.getWritinglist(this.page).then(res => {
        if (res.code == 0) {
          this.listData = res.data.records;
          this.total = res.data.total;
          this.pages = res.data.pages;
        }
      });
    },
    /**
     * 分页器
     */
    handleCurrentChange: function(val) {
      this.page.current = val;
      this.initData();
    },

    // 跳转至会员中心
    goVip() {
      // this.oauthapi.vipRedirectUrl().then(res => {
      //   if (res.code == 0) {
      //     window.open(res.data.attributeValue, "_blank");
      //   }
      // });
      this.opneVipVisible  = false;
      this.dialogVisible = true;
    },
    /** 获取论文导出次数 */
    /*getExportTimes() {
      this.api.getToolsLimitCheck({ type: 2 }).then(res => {
        if (res.code == 0) {
          this.exportTimes = 1;
        } else {
          this.exportTimes = 0;
        }
      });
    },*/
    /** 导入引导限制获取 */
    getGuideLimit() {
      this.api.getGuideLimit({ type: 1 }).then(res => {
        if (res.code == 0) {
          if (res.data) {
            let importDocBtn = document.getElementById("importDocBtn");
            importDocBtn.style = "z-index:2001;background:#ffffff";
            const h = this.$createElement;
            this.$msgbox({
              title: "查重步骤",
              message: "1. 点击导入本地论文文件",
              customClass: "import-guide",
              confirmButtonText: "立即导入",
              confirmButtonClass: "import-guide-btn",
              roundButton: true,
              beforeClose: (action, instance, done) => {
                if (action === "confirm") {
                  done();

                  importDocBtn.click();
                } else {
                  done();
                }
              }
            }).then(action => {});
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.writing {
  background: #f5f6fa;
  min-height: calc(100vh - 70px);

  .pages {
    padding-bottom: 30px;
  }

  .row {
    display: flex;
    width: $mWidth;
    margin: 0 auto;
    padding: 120px 0;
    flex-wrap: wrap;

    .colspan {
      width: 368px;
      margin: $mWidth/3 - 385px;
      height: 209px;
      background: #ffffff;
      box-shadow: 0px 0px 16px rgba(11, 19, 54, 0.12);
      border-radius: 8px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      align-items: center;

      div {
        width: 100%;
        height: 100%;
        cursor: pointer;

        h3 {
          font-size: 20px;
          font-weight: 500;
          color: #333333;
          margin: 24px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        p {
          font-size: 16px;
          color: #999999;
          padding: 0 24px;
          margin-bottom: 11px;
          display: flex;
          align-items: center;

          img {
            margin-right: 5px;
            width: 17px;
          }
        }
      }

      .btn {
        height: 58px;
        border-top: 2px solid #f7f7f7;
        font-size: 16px;
        line-height: 58px;
        width: calc(100% - 48px);

        display: flex;
        justify-content: space-between;
        padding: 0 24px;

        button {
          background: none;
          border: none;
          color: $btnc;
          font-size: 16px;
          display: flex;
          align-items: center;
          height: 100%;
          cursor: pointer;

          img {
            margin-right: 10px;
            width: 19px;
            margin-top: -4px;
          }
        }
      }
    }

    .gd {
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      width: 90px;

      button {
        background: none;
        border: none;
      }
    }

    .col {
      width: 368px;
      height: 209px;
      // padding: 10px;
      margin: $mWidth/3 - 385px;
      background: #ffffff;
      box-shadow: 0px 0px 16px rgba(11, 19, 54, 0.12);
      border-radius: 8px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      align-items: center;

      .imgbox {
        width: 55px;
        height: 55px;

        img {
          width: 55px;
          height: 55px;
        }
      }

      div {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        cursor: pointer;

        h3 {
          font-weight: 400;
          font-size: 20px;
          color: $btnc;
          margin-top: 10px;
        }
      }

      .btn {
        min-height: 58px;
        height: 58px;
        border-top: 2px solid #f7f7f7;
        font-size: 16px;
        color: #999999;
      }
    }
  }

  .files {
    display: none;
  }

  h5 {
    font-size: 16px;
    color: #333439;
    margin-bottom: 37px;
  }
}

 .limit-open-vip {
   /deep/ .el-dialog__title{
     font-weight: bold;
   }
 }

 .open-vip-box{
    display:flex;
    flex-direction: column;
    align-items:center;
    justify-content:space-between;

    .open-vip-box-message{
      margin-bottom: 20px;
    }

    .check-glod-btn {
      width: 134px;
      height: 36px;
      background: #c79758;
      opacity: 1;
      border-radius: 18px;
      border: none;
    }
    .check-btn-text {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 12px;
      color: #ffffff;
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/writing/writing.vue